import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Cutttingedge(props) {
  return (
    <div className="p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="App">
              <h2>
                We've delivered 100+ bespoke digital solutions customized to
                meet the diverse needs of our clients.
              </h2>
            </div>
            <p>
              From software design to development and implementation, we've done
              it all!
            </p>

            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Let’s Connect!
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Cutttingedge;
